import React, { useCallback, useState } from "react";
import { Box } from "@mui/material";
import AgentLayout from "../../../agentComponents/AgentLayout";
import AttendancePanel from "./AttendancePanel";
import AttendanceHistory from "./AttendanceHistory";

const AgentAttendance = () => {
  // Clocking out finishes a shift, which belongs in the log below -- but the
  // log loads on its own. Bumping this tells it to re-fetch, so a finished
  // shift appears without the agent reloading the page.
  const [version, setVersion] = useState(0);
  const onChanged = useCallback(() => setVersion((v) => v + 1), []);

  return (
    <AgentLayout
      title="My Attendance"
      subtitle="Clock in when you start, log every break, and clock out when you finish."
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <AttendancePanel onChanged={onChanged} />
        <AttendanceHistory refreshKey={version} />
      </Box>
    </AgentLayout>
  );
};

export default AgentAttendance;
